// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"8be7b78e","823":"5b0ff196","871":"3d9dd206"}[chunkId] + ".chunk.js";
};